/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { StandaloneImage as ResolvedStandaloneImage } from 'base/components/standalone/Image';

export const Image: typeof ResolvedStandaloneImage = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneImage {...props} />
    );
});

export type ImageProps = PropsFromComponent<typeof Image>;

/** @deprecated Use slot architecture instead */
export const ImageWith = (extras: DynamicStandaloneExtras): typeof Image => {
    return function Image(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Image');
        return <ResolvedStandaloneImage {...mergeProps({ options: { theme } }, props)} />;
    }
}